import React, { useEffect } from 'react'
import Home from 'components/pages/home/home.component'
import { Routes, Route } from 'react-router-dom'
import ContactInformation from 'components/pages/contact-information/contact-information'
import DeliveryInformation from 'components/pages/delivery-information/delivery-information'
import PaymentComponent from 'components/pages/payment/payment'
import ConfirmationComponent from 'components/pages/confirmation/confirmation'
import HeaderSummary from 'components/organisms/header-summary/header-summary.component'
import { initializeConfig } from 'config/setup-cofig'
import { setInitRentalAction, useAppDispatch } from 'store/rentals-store'
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';

export enum Path {
  Home = "/",
  Contact = "/contact",
  Delivery = "/delivery",
  Payment = "/payment",
  Confirmation = "/confirmation"
}

export default function App () {
  initializeConfig()
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setInitRentalAction())
  }, [])

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Routes>
        <Route path={Path.Home} element={<HeaderSummary />}>
          <Route index element={<Home />} />
          <Route path={Path.Contact} element={<ContactInformation />} />
          <Route path={Path.Delivery} element={<DeliveryInformation />} />
          <Route path={Path.Payment} element={<PaymentComponent />} />
          <Route path={Path.Confirmation} element={<ConfirmationComponent />} />
          <Route path="*" element={<div>La página que busca no existe</div>}/>
        </Route>
      </Routes>
    </LocalizationProvider>
  )
}
